module.exports = __webpack_public_path__ + "img/bg.91d8cc1c.jpg";